import { useCallback, useState } from 'react';

export default function usePagination(initial = { page: 0, size: 20 }) {
  const clampPage = (p) => Math.max(0, Number.isFinite(p) ? p : 0);
  const clampSize = (s) => {
    const n = Number(s);
    if (!Number.isFinite(n)) return 20;
    return Math.min(Math.max(1, n), 100);
  };

  const [page, setPage] = useState(clampPage(initial.page));
  const [size, setSize] = useState(clampSize(initial.size));

  const next = useCallback(() => setPage((p) => clampPage(p + 1)), []);
  const prev = useCallback(() => setPage((p) => clampPage(p - 1)), []);
  const setPageSize = useCallback((s) => setSize(clampSize(s)), []);
  const reset = useCallback(() => {
    setPage(clampPage(initial.page));
    setSize(clampSize(initial.size));
  }, [initial.page, initial.size]);

  return { page, size, next, prev, setPageSize, reset };
}
